import * as HttpService from './http.service';
import * as URL from './url.service';

export const calculateNdfZeroRates = (data) => HttpService.postWithAuth(URL.CALCULATE_NDF_ZERO_RATES(), data);
export const calculateNdfZeroRatesHistory = (data) => HttpService.postWithAuth(URL.CALCULATE_NDF_ZERO_RATES_HISTORY(), data);
export const calculateNdFwdRates = (data) => HttpService.postWithAuth(URL.CALCULATE_NDF_FWD_RATES(), data);
export const calculateNdFwdRatesHistory = (data) => HttpService.postWithAuth(URL.CALCULATE_NDF_FWD_RATES_HISTORY(), data);
